import { Container } from "inversify";
import { TYPES } from "@utils/inversifyJS/types";
import { CreateJobService } from "@application/useCases/job/CreateJobService";
import { IPipelineRepository, IRawFileRepository, IResultsRepository, ISoftwareVersionsRepository, IUserRepository } from "@domain/repositories";
import { JobRepository, LicenseRepository, PipelineRepository, ResultsRepository, SoftwareVersionsRepository, UserRepository } from "@infrastructure/repositories";
import { IJobRepository, ISoftwareSettingsRepository } from "@domain/repositories";
import { SoftwareSettingsRepository } from "@infrastructure/repositories/SoftwareSettingsRepository";
import { AuthService, AuthenticatedRequestHandlerService } from "@infrastructure/services";
import { IFastaRepository } from "@domain/repositories/IFastaRepository";
import { FastaRepository } from "@infrastructure/repositories/FastaRepository";
import { UploadFastaService } from "@application/useCases/fasta/UploadFastaService";
import { ListFastaService } from "@application/useCases/fasta/ListFastaService";
import { DeleteFastaService } from "@application/useCases/fasta/DeleteFastaService";
import { DeleteSoftwareSettingsService } from "@application/useCases/softwareSettings/DeleteSoftwareSettingsService";
import { ListJobsService } from "@application/useCases/job/ListJobTasksService";
import { ChangePassword, ListPipelineService } from "@application/useCases";
import { IAuthenticatedRequestHandlerService, IAuthService } from "@application/contracts/services";
import { RawFileRepository } from "@infrastructure/repositories/RawFileRepository";
import { SaveLicenseService } from "@application/useCases/license/SaveLicenseService";
import { ILicenseRepository } from "@domain/repositories/ILicenseRepository";
import { UploadRawFileService } from "@application/useCases/rawFiles/UploadRawFileService";
import { UploadLibraryService } from "@application/useCases/library/UploadLibraryService";
import { LibraryRepository } from "@infrastructure/repositories/LibraryRepository";

const DIContainer = new Container();

DIContainer.bind<CreateJobService>(TYPES.CreateJobService).to(CreateJobService);
DIContainer.bind<IJobRepository>(TYPES.IJobRepository).to(JobRepository);
DIContainer.bind<IPipelineRepository>(TYPES.IPipelineRepository).to(PipelineRepository);
DIContainer.bind<ListPipelineService>(TYPES.ListPipelineService).to(ListPipelineService);
DIContainer.bind<IUserRepository>(TYPES.IUserRepository).to(UserRepository);
DIContainer.bind<ISoftwareSettingsRepository>(TYPES.ISoftwareSettingsRepository).to(SoftwareSettingsRepository);
DIContainer.bind<ISoftwareVersionsRepository>(TYPES.ISoftwareVersionsRepository).to(SoftwareVersionsRepository);
DIContainer.bind<IAuthenticatedRequestHandlerService>(TYPES.IAuthenticatedRequestHandlerService).to(AuthenticatedRequestHandlerService);
DIContainer.bind<IFastaRepository>(TYPES.IFastaRepository).to(FastaRepository);
DIContainer.bind<UploadFastaService>(TYPES.UploadFastaService).to(UploadFastaService);
DIContainer.bind<ListFastaService>(TYPES.ListFastaService).to(ListFastaService);
DIContainer.bind<ListJobsService>(TYPES.ListJobsService).to(ListJobsService);
DIContainer.bind<IAuthService>(TYPES.IAuthService).to(AuthService).inSingletonScope();
DIContainer.bind<IRawFileRepository>(TYPES.IRawFileRepository).to(RawFileRepository);
DIContainer.bind<SaveLicenseService>(TYPES.SaveLicenseService).to(SaveLicenseService);
DIContainer.bind<ILicenseRepository>(TYPES.ILicenseRepository).to(LicenseRepository);
DIContainer.bind<IResultsRepository>(TYPES.IResultsRepository).to(ResultsRepository);
DIContainer.bind<ChangePassword>(TYPES.ChangePassword).to(ChangePassword);
DIContainer.bind<DeleteFastaService>(TYPES.DeleteFastaService).to(DeleteFastaService);
DIContainer.bind<DeleteSoftwareSettingsService>(TYPES.DeleteSoftwareSettingsService).to(DeleteSoftwareSettingsService);
DIContainer.bind<UploadRawFileService>(TYPES.UploadRawFileService).to(UploadRawFileService).inSingletonScope();
DIContainer.bind<LibraryRepository>(TYPES.LibraryRepository).to(LibraryRepository);
DIContainer.bind<UploadLibraryService>(TYPES.UploadLibraryService).to(UploadLibraryService);

export { DIContainer };
